export interface IChangeCurrentUserPasswordResponse {
  successful: boolean;
  message: string;
}

export class ChangeCurrentUserPasswordResponse
  implements IChangeCurrentUserPasswordResponse {
  successful: boolean;
  message: string;
}
